<!-- 此component用來顯示檔案的詳細資訊 -->
<template>
	<section>
	<div class="info">
		<!-- left area -->
		<el-col v-loading="loading" :span="16" class="info-table">
			<div class="info-name"> 
				{{info.name}}  
				<div v-if="isFavorite" class="like-icon" @click="removeFavorite()">
					<img src="../../assets/icon/ic_like_red.png" >
				</div>
				<div v-else class="like-icon" @click="addFavorite()">
					<img src="../../assets/icon/ic_like_grey.png" >
				</div>
				<div class="infoCompulsory" v-if="info.course_type === 1">必修</div>
              	<div class="infoElective" v-if="info.course_type === 0">選修</div>
			</div>
			<div class="info-description"> {{info.description}} </div>
			<div class="info-data">
				<div v-for="(title, index) in info.titles" :key="index" class="info-title"> {{title}} 
					<div v-if="index === 6" class="info-item">
						<el-button type="text" @click="clickAuthor" class="author-item" > {{ info.items[index] }} </el-button>
					</div>
					<div v-else class="info-item"> {{info.items[index]}} </div>
				</div>
			</div>
			<!-- 評價區 -->
			<div class="info-comment">
				<!--  我的評價 -->
				<div v-if="myComment" class="info-my-comment">
					<span class="comment-title">我的評價</span>
					<div class="my-info" v-bind:id="myComment.id">
						<div class="my-comment">
							<span class="my-userinfo">
								<img class="user-img" src="../../assets/icon/ic_user_2.png" alt="U"> 
								<span v-if="myComment.anonymous === 0" class="user-name"> {{myComment.author.username + ' (' + myComment.author.displayname + ')'}}</span>
								<span v-else class="user-name"> 匿名 </span>
								<img src="../../assets/icon/ic_edit.png" alt="E" title="編輯評價" class="edit-icon" @click="commentControl(true, myComment, 1)">
								<img v-show="$store.state.isSystemAdminMode" src="../../assets/icon/ic_delete.png" alt="D" title="刪除評價" class="delete-icon" @click="myCommentDelete(myComment)">
							</span>
							<div class="my-star-date">
								<StarRating 
									class="my-star" 
									:rating="myComment.rating" 
									:show-rating="false" 
									:max-rating="5" 
									:star-size="16" 
									:read-only="true" 
									:increment="1">
								</StarRating>
								<span class="my-date">
									{{formatCtime(myComment.ctime)}}
								</span>
							</div>
							<span class="my-message">
								{{myComment.comment}}
							</span>
						</div>
						<span v-show="myComment.reply.content" class="my-comment-reply">
							<span class="reply-row">
								<span class="reply-title">作者回覆</span>
								<span class="reply-date"> {{formatCtime(myComment.reply.mtime)}} </span>
							</span>
							<span class="reply-message"> {{myComment.reply.content}} </span>
						</span>
					</div>		
				</div>

				<!-- 資源評分 -->	
				<div v-show="showRatingTable" class="info-rating">
					<div class="info-rating-score">
						<div class="info-score">{{info.aveRating}}</div>
						<StarRating class="info-star" 
												:rating="info.aveRating" 
												:show-rating="false" 
												:max-rating="5" 
												:star-size="17" 
												:read-only="true" 
												:increment="0.1">
						</StarRating>
						<div class="info-total-score">{{'共' + info.totalRating + "個評分"}}</div>
					</div>
					<div class="info-rating-bar">
						<div class="row-bar" :title="info.ratingBar[0]">
							<div class="left-bar">5</div>
							<div class="right-bar">
								<div class="bar-container">
									<div class="bar-5" style="width: 0%"></div>
								</div>	
							</div>
						</div>
						<div class="row-bar" :title="info.ratingBar[1]">
							<div class="left-bar">4</div>
							<div class="right-bar">
								<div class="bar-container">
									<div class="bar-4" style="width: 0%"></div>
								</div>	
							</div>
						</div>
						<div class="row-bar" :title="info.ratingBar[2]">
							<div class="left-bar">3</div>
							<div class="right-bar">
								<div class="bar-container">
									<div class="bar-3" style="width: 0%"></div>
								</div>	
							</div>
						</div>
						<div class="row-bar" :title="info.ratingBar[3]">
							<div class="left-bar">2</div>
							<div class="right-bar">
								<div class="bar-container">
									<div class="bar-2" style="width: 0%"></div>
								</div>	
							</div>
						</div>
						<div class="row-bar" :title="info.ratingBar[4]">
							<div class="left-bar">1</div>
							<div class="right-bar">
								<div class="bar-container">
									<div class="bar-1" style="width: 0%"></div>
								</div>	
							</div>
						</div>
					</div>
				</div>

				<!-- 評價按鈕 -->
				<el-button v-show="!myComment" class="comment-btn" @click="commentControl(true)">
					<img src="../../assets/icon/ic_edit.png" alt="W"> 撰寫評價
				</el-button>	

				<!-- 新增及回覆評價視窗-->
				<comment 
					v-if="commentWindow.display"
					:resourceId="info.id"
					:name="commentWindow.user"
					:rating="commentWindow.rating"
					:date="commentWindow.date"
				  :content="commentWindow.content" 
					:reply="commentWindow.reply"
					:anonymous="commentWindow.anonymous"
					:status="commentWindow.status"
					:id="commentWindow.id"
					@close="commentControl(false)" 
					@reply="replyComment"
					@release="releaseComment"
					@change="changeComment">
				</comment>

				<!-- 資源評論 -->
				<div>
					<div 
					  v-for="(comment, index) in commentList"
						v-bind:id="comment.id"
						:key="index"
						class="other-info">
						<span class="other-userinfo">
							<img class="user-img" src="../../assets/icon/ic_user_2.png" alt="U" > 
							<span v-if="comment.anonymous === 0" class="user-name"> {{comment.author.username + ' (' + comment.author.displayname + ')'}} </span>
							<span v-else class="user-name"> 匿名 </span>
							<el-button v-show="isAuthor && !comment.reply.content" class="reply-btn" @click="commentControl(true, comment, 2)">回覆</el-button>	
							<el-button v-show="isAuthor && comment.reply.content" class="change-reply-btn" @click="commentControl(true, comment, 2)">修改回覆</el-button>
							<img v-show="$store.state.isSystemAdminMode" src="../../assets/icon/ic_delete.png" alt="D" title="刪除評價" class="delete-icon" @click="otherCommentDelete(comment)">
						</span>
						<div class="other-star-date">
							<StarRating 
								class="other-star" 
								:rating="comment.rating" 
								:show-rating="false" 
								:max-rating="5" 
								:star-size="16" 
								:read-only="true" 
								:increment="1">
							</StarRating>
							<span class="other-date">
								{{formatCtime(comment.mtime)}}
							</span>
						</div>
						<span class="other-comment">
							{{comment.comment}}
						</span>
						<span v-show="comment.reply.content" class="other-reply-comment">
							<span class="reply-row">
								<span class="reply-title">作者回覆</span>
								<span class="reply-date"> {{formatCtime(comment.reply.mtime)}} </span>
							</span>
							<span class="reply-message"> {{comment.reply.content}} </span>
						</span>
					</div>		
				</div>	
			</div>
		</el-col>  

		<!-- right area -->
		<el-col :span="8">
			<div v-loading="loading" class="info-card">
				<div class="info-card-title">檔案瀏覽</div>
				<div v-for="file in files" :key="file.name" class="info-card-column">
					<img v-show="file.type === 'doc'" src="../../assets/icon/ic_document.png" alt="C" class="info-card-icon">
					<img v-show="file.type === 'video'" src="../../assets/icon/ic_video.png" alt="V" class="info-card-icon">
					<a class="info-card-file" @click="onlineView(file)" target="_blank">{{file.name}}</a>
					<!-- 只有管理者才有的下載 -->
					<div v-show="backendMode" class="tooltip" @click="download(file)">
						<img src="../../assets/icon/ic_download.png" alt="D" class="info-download-icon">
						<span class="tooltiptext">下載附件</span>
					</div>
				</div>
			</div>
		</el-col>
		<hint v-show="hint.display && this.$store.state.hintStatus.info" :message="hint.message" @close="closeHint"></hint>  
	</div>
	<div  ref="addFavoriteDiv" v-if="showAddFavorite" class="centered add-favorite-message"> 
		已加入我的最愛 <br/><br/>
		<img src="../../assets/icon/ic_like_red.png">
	</div>
	</section>
</template>

<script>
	import API from '../../api/api';
	export default {
		data() {
			return {
				loading: false,
				info: {
					id: '',
					name: '',
					description: '',
					titles: ['編號', '部門', '科普分類', '適合程度', '僅部門會員閱覽', '關鍵字', '作者',''],
					items:['', '', '', '', '', '', ''],
					aveRating: 0,
					totalRating: 0,
					ratingBar:[0, 0, 0 ,0, 0],
					commentId: '',
					author: null,
					authorName: null,
				},
				files: [],
				//跳出hint
				hint: {
					message: '',
					display: false,
				},
				timer: null,
				backendMode: false,
				showRatingTable: false,
				isAuthor: false,
				commentWindow: {
					id: null,
					user: '',
					rating: 0,
					content: '',
					display: false,
					replay: '',
					status: 0,
					anonymous: 0,
				},
				myComment: null,
				commentList:[],
				isFavorite: false,
				showAddFavorite: false,
			}
		},
		beforeCreate() {
			//取得使用者資訊
			API.getUser().then((result) => {
				if(result.status) {
					redirectLogin(result.data);
					if(!JSON.parse(result.request.response).error_msg) {
						this.showHint('取得使用者資訊錯誤!');
					} else {
						this.showHint(JSON.parse(result.request.response).error_msg);
					}
				} else {
					//update username
					this.$store.state.userName = result.name;
					//取得部門管理者清單
					API.accountInfo(this.$store.state.userName).then((response) => {
						if(response.status !== 0 && response.status !== 1) {
							redirectLogin(response.data);
						} else {
							this.$store.state.userDepId = response.depId;
							this.$store.state.userActualDepId = response.actual_depid;
							if(response.isManager === 2) {
								this.$store.state.isSystemAdminMode = true;
								this.$store.state.isBackendMode = true;
							} else if(response.isManager === 1) {
								this.$store.state.isSystemAdminMode = false;
								this.$store.state.isBackendMode = true;
							} else {
								this.$store.state.isSystemAdminMode = false;
								this.$store.state.isBackendMode = false;	
							}

							//返回info如果前一頁是線上瀏覽要刪除動態建置的浮水印
							if((this.$store.state.nowStatus === 5 || this.$store.state.nowStatus === 6) && this.$store.state.isSystemAdminMode === false) {
								if (document.getElementById('_waterMark')) {
									document.getElementsByClassName('main')[0].removeChild(document.getElementById('_waterMark'));
								}
							}
							this.initial();
						}
					});					
				}
			});
		},
		created() {
			this.loading = true;
			this.info.id = Number(location.hash.split('/')[2].split('&')[0]);
			this.info.commentId = location.hash.split('/')[2].split('&')[1];
		},
		updated() {
			if(this.info.commentId && !this.loading) {
				if(!this.info.id) {
					this.$alert('找不到此資源，請確認資源 ID 是否正確或是否具有權限瀏覽', '提示', {
							confirmButtonText: '確定',
							showClose: false
						}).then(() => {
							this.$router.push({ path: '/table' });
							return;
						});
					return;
				}
				if(document.getElementById(this.info.commentId)) {
					document.getElementById(this.info.commentId).scrollIntoView();	
					this.info.commentId = null;
					this.$router.push({ path: '/info/' +  this.info.id});	
				} else {
					this.$alert('找不到此評價，評價已被刪除', '提示', {
						confirmButtonText: '確定',
					}).then(() => {
						this.info.commentId = null;
						this.$router.push({ path: '/info/' +  this.info.id});
						return;
					});
				}
			}
		},
		methods: {
			initial: function() {
				this.$store.state.editResourceBreadcrumbs = [];
				this.$store.state.nowStatus = 1;
				this.files= [];
				this.myComment = null;
				this.$store.state.infoDepId = null;
				this.$store.state.infoActualDepId = null;
				this.commentList = [];
				this.getResourceDetail(this.info.id);
			},
			/**
			  * getResourceDetail 取得單一資源
    		* @param  {number}    resoureId                    - 特定資源的ID
			  * @return {object}    result                       - 結果陣列
			  * @return {number}    result.id                    - 資源Id
			  * @return {string}    result.code                  - 資源編碼
			  * @return {string}    result.title                 - 資源標題
			  * @return {string}    result.description           - 資源敘述
			  * @return {object}    result.category              - 資源主題分類
			  * @return {number}    result.category.id           - 資源主題分類Id
			  * @return {string}    result.category.code         - 資源主題分類代碼
			  * @return {string}    result.category.title        - 資源主題分類標題
				* @return {object}    result.dep                   - 部門
        * @return {number}    result.dep.id                - 部門Id
  	    * @return {string}    result.dep.title             - 部門標題
			  * @return {number}    result.level                 - 資源級別
			  * @return {number}    result.secret                - 資源機密
			  * @return {number}    result.ctime                 - 資源建立時間
			  * @return {string[]}  result.keywords              - 資源關鍵字
			  * @return {object}    result.fileAttrs             - 資源附檔
			  * @return {string}    result.fileAttrs.fileid      - 資源附檔fileid
			  * @return {string}    result.fileAttrs.filename    - 資源附檔
			  * @return {string}    result.fileAttrs.type        - 資源附檔檔案類型
			  * @return {string}    result.fileAttrs.downloadurl - 資源附件下載連結
			  */  
			getResourceDetail(resoureId) {
				API.getResourceDetail(resoureId).then((response) => {
					console.log(response);
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('取得資源細節錯誤!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);	
						}
						this.info.id = null;
						this.loading = false;
						this.$alert('找不到此資源，請確認資源 ID 是否正確或是否具有權限瀏覽', '提示', {
							confirmButtonText: '確定',
							showClose: false
						}).then(() => {
							if (this.$store.state.entrance === "personalReport") {
								this.$router.push({ path: '/report'});
							} else {
								this.$router.push({ path: '/table' });
							}
							return;
						});
					} else {
						this.$store.state.editResourceId = [];
						this.$store.state.editResourceFileAttrs = [];
						let categoryGroup = {
							'id': response.category_group.id,
							'name' : response.category_group.name,
						}
						this.$store.state.editResourceBreadcrumbs.push(categoryGroup);
						let category = {
							'id': response.category.id,
							'name' : response.category.title,
						}
						this.$store.state.editResourceBreadcrumbs.push(category);
						this.$store.state.editResourceBreadcrumbs.push(response.title);
						this.info.name = response.title;
						this.info.course_type = response.course_type;
						this.isFavorite = response.favorite;
						this.info.description = response.description;
						this.info.id = response.id;
						this.$store.state.editResourceId.push(response.id);
						this.$store.state.editResourceFileAttrs.push(response.fileAttrs);

						//update items
						//編號
						this.info.items[0] = response.code;
						//部門
						this.info.items[1] = response.actual_dep.name;
						this.$store.state.infoDepId = response.depId;
						this.$store.state.infoActualDepId = response.actual_depid;
						//// dep admin file download permission
						this.backendMode = this.$store.state.isSystemAdminMode ||
							(this.$store.state.isBackendMode && 
							(this.$store.state.infoActualDepId === this.$store.state.userActualDepId));
						//科普分類
						this.info.items[2] = response.category.title;
						//適合程度
						this.info.items[3] = 'Level ' + response.level;
						//僅部門會員閱覽
						this.info.items[4] = response.secret? '是':'否';
						//關鍵字
						let tempstring = '';
						if(response.keywords.length > 0) {
							for(let i = 0 ; i < response.keywords.length ; i++) {
								if(i === response.keywords.length - 1) {
									tempstring = tempstring + response.keywords[i];	
								} else {
									tempstring = tempstring + response.keywords[i] + ' 、 ';	
								}
							}
						}
						this.info.items[5] = tempstring;
						//作者
						if(response.author.username !== '') {
							this.info.items[6] = response.author.username + ' (' + response.author.displayname + ')';
							if(this.$store.state.userName === response.author.username) {
								this.isAuthor = true;
							} else {
								this.isAuthor = false;
							}
							this.author = response.author.username;
							this.authorName = response.author.displayname;
						} else {
							this.info.items[6] = '';
							this.isAuthor = false;
						}

						//update fileattrs
						if(response.fileAttrs.length > 0) {
							for(let j = 0 ; j < response.fileAttrs.length ; j++) {
								let file = response.fileAttrs[j];
								file.ext = file.name.split('.').pop();
								this.files.push(file)
							}
							function sortFiles(a, b) {
								if (a.type < b.type) return -1;
								if (a.type > b.type) return 1;
								if (a.ext < b.ext) return -1;
								if (a.ext > b.ext) return 1;
								if (a.name < b.name) return -1;
								if (a.name > b.name) return 1;
								return 0;
							}
							this.files = this.files.sort(sortFiles);
						}

						this.myComment = response.myreview;
						this.commentList = response.reviews;

						if(response.rating) {
							this.setRatingTable(response.rating.average, response.rating.count, response.rating.countlist);
						} else {
							this.setRatingTable(0, 0, [0, 0, 0, 0, 0]);	
						}
						
						this.loading = false;
					}
				});
			},
			/**
				* download 下載附件
				* @param  {object}    file        - fileobject
				* @return {string}    downloadURL - downloadlink
				*/
			download: function(file) {
				API.downloadResource(this.info.id, file.fileid).then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('下載附件錯誤!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);	
						}
					} else {
						window.location = response.downloadURL;
					}
				});
				//blob download
				/*
				if(file.type === 'doc') {
					blobFile(file.downloadurl, "application/pdf", file.name);
				} else {
					blobFile(file.downloadurl, "video/mp4", file.name);
				}

				function blobFile(url, mime, filename) {
					let promise = new Promise((resolve, reject) => {
							let xhr = new XMLHttpRequest();
							xhr.onload = () => {
									let blob = new Blob([xhr.response], { type: mime });
									let href = URL.createObjectURL(blob);
									let a = document.createElement('a');
									a.href = href;
									a.target = '_blank';
									a.setAttribute('download', filename);
									a.click();
									setTimeout(function() {
							// For Firefox it is necessary to delay revoking the ObjectURL
							URL.revokeObjectURL(href),100
						});
									resolve();
							}

							xhr.onerror = (err) => {
									reject(err);
							}

							xhr.open('GET', url);
							xhr.setRequestHeader('Authorization', 'Bearer '+ justupSDK.getCookie('access_token'));
							xhr.responseType = 'blob';
							xhr.send();
				});
				return promise;
			*/
			},
			/**
				* onlineView 線上觀看附件
				* @param  {object}    file        - fileobject
				* @return none
				*/
			onlineView: function(file) {
				if(file.type === 'doc') {
					this.$router.push({ path: '/pdfView/' + this.info.id + '&' + file.fileid});
				} else if(file.type === 'video') {
					this.$router.push({ path: '/videoView/' + this.info.id + '&' + file.fileid});
				} else {
					this.$alert('此檔案類型目前不支援線上瀏覽', '提示', {
						confirmButtonText: '確定',
					}).then(() => {

					});
				}
			},
			/**
				* closeHint close hint 視窗
				* @return none
				*/
			closeHint: function() {
				this.hint.display = false;
				this.$store.state.hintStatus.info = false;
				clearTimeout(this.timer);
			},
			/**
				* showHint 
				* @param  {string} message - message
				* @return none
				*/
			showHint: function(message) {
				if(this.timer) {
					clearTimeout(this.timer);	
				}
				this.hint.display = true;
				this.hint.message = message;	
				this.$store.state.showHint = true;
				this.$store.state.hintStatus.info = true;
				this.timer = setTimeout(()=>{
					if(this.$store.state.showHint) {
							this.$store.state.showHint = false;
							this.$store.state.hintStatus.info = false;
						}
					}, this.$store.state.fadeOutTime
				);
			},
			/**
				* commentControl 視窗
				* @return none
				*/
			commentControl: function(visable, comment, status) {
				if(!visable) {
					this.$confirm('確定取消嗎 ?', '提示', {
						confirmButtonText: '確定',
          	cancelButtonText: '取消',
					}).then(_ => {
						this.commentWindow.display = visable;
						this.$store.state.editResource.myComment.anonymous = comment.anonymous;
          }).catch(_ => {});
				} else {
					this.commentWindow.display = visable;	
					if(comment) {
						if(comment.author) {
							this.commentWindow.user = comment.author.username;
						} else {
							this.commentWindow.user = '匿名';
						}
						this.commentWindow.rating = comment.rating;
						this.commentWindow.content = comment.comment;
						this.commentWindow.date = this.formatCtime(comment.mtime);
						this.commentWindow.reply = comment.reply.content;
						this.commentWindow.status = status;
						this.commentWindow.id = comment.id;
						this.commentWindow.anonymous = comment.anonymous;
					} else {
						this.commentWindow.user = this.$store.state.userName;	
						this.commentWindow.rating = 0;
						this.commentWindow.content = '';		
						this.commentWindow.date = this.formatCtime(Date.now() / 1000);
						this.commentWindow.reply = '';
						this.commentWindow.status = 0;
						this.commentWindow.id = null;
						this.commentWindow.anonymous = 0;
					}
				}
			},
			/**
				* replyComment
				* @return none
				*/
			replyComment: function() {
				this.$confirm('確定回覆評價嗎 ?', '提示', {
					confirmButtonText: '確定',
          cancelButtonText: '取消',
				}).then(_ => {
					if(this.$store.state.editResource.reply === '' || !this.$store.state.editResource.reply) {
          	this.$alert('回覆不能為空', '警告', {
					  	confirmButtonText: '確定',
				  	}).then(() => {
							return;					
						});
					} else {
						this.loading = true;
						API.replyComment(this.commentWindow.id, 
														this.$store.state.editResource.reply).then((response) => {
							this.commentWindow.display = false;
							if(response.status) {
								redirectLogin(response.data);
								this.loading = false;
								if(!JSON.parse(response.request.response).error_msg) {
									this.showHint('回覆評價錯誤!');
								} else {
									this.showHint(JSON.parse(response.request.response).error_msg);	
								}
							} else {
								this.initial();
							}
						});
					}
        }).catch(_ => {});
			},
			/**
				* releaseComment 發怖評價
				* @return none
				*/
			releaseComment: function() {
        if(this.$store.state.editResource.myComment.rating === 0) {
          this.$alert('您必須至少填寫評分才能發怖', '提示', {
					  confirmButtonText: '確定',
				  }).then(() => {
						return;					
					});
        } else {
          this.$confirm('確定發佈此則評價嗎 ?', '提示', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then(() => {
						this.loading = true;
						API.addComment(this.info.id, 
													 this.$store.state.editResource.myComment.rating, 
													 this.$store.state.editResource.myComment.content,
													 this.$store.state.editResource.myComment.anonymous).then((response) => {
							this.commentWindow.display = false;
							if(response.status) {
								redirectLogin(response.data);
								this.loading = false;
                if(!JSON.parse(response.request.response).error_msg) {
                  this.showHint('新增評價錯誤!');
                } else {
                  this.showHint(JSON.parse(response.request.response).error_msg);	
                }
              } else {
								this.initial();
              }
            });
          }).catch(() => {
            
          });
        }
			},
			/**
				* changeComment 修改評價
				* @return none
				*/
			changeComment: function() {
        if(this.$store.state.editResource.myComment.rating === 0) {
          this.$alert('您必須至少填寫評分才能發怖', '提示', {
					  confirmButtonText: '確定',
				  }).then(() => {
						return;					
					});
        } else {
          this.$confirm('確定修改此則評價嗎 ?', '提示', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then(() => {
						this.loading = true;
						API.changeComment(this.$store.state.editResource.myComment.id, 
													 		this.$store.state.editResource.myComment.rating, 
															this.$store.state.editResource.myComment.content,
															this.$store.state.editResource.myComment.anonymous).then((response) => {
							this.commentWindow.display = false;
							if(response.status) {
								redirectLogin(response.data);
								this.loading = false;
                if(!JSON.parse(response.request.response).error_msg) {
                  this.showHint('新增評價錯誤!');
                } else {
                  this.showHint(JSON.parse(response.request.response).error_msg);	
                }
              } else {
								this.initial();
              }
            });
          }).catch(() => {
            
          });
        }
      },
			/**
				* myCommentDelete 刪除我的評價
				* @return none
				*/
			myCommentDelete: function(myComment) {
				let message = "";
				if(myComment.reply.content) {
					message = '刪除我的評價，會連同作者回覆一起刪掉，確定刪除 ?';
				} else {
					message = '確定刪除我的評價嗎 ?'
				}

				this.$confirm(message, '提示', {
					confirmButtonText: '確定',
          cancelButtonText: '取消',
				}).then(_ => {
					this.loading = true;
					API.deleteComment(myComment.id).then((response) => {
						if(response.status) {
							redirectLogin(response.data);
							this.loading = false;
							if(!JSON.parse(response.request.response).error_msg) {
								this.showHint('刪除我的評價錯誤!');
							} else {
								this.showHint(JSON.parse(response.request.response).error_msg);	
							}
						} else {
							this.initial();	
						}
					});	
				}).catch(_ => {});
			},
			/**
				* otherCommentDelete 刪除其他人的評價
				* @return none
				*/
			otherCommentDelete: function(comment) {
				//代表作者有回覆
				let message = "";
				if(comment.reply.content) {
					if(comment.anonymous === 1) {
						message = '刪除評價，會連同作者回覆一起刪掉，確定刪除 ?';
					} else {
						message = '刪除 ' + comment.author.displayname + ' 的評價，會連同作者回覆一起刪掉，確定刪除 ?';	
					}
				} else {
					if(comment.anonymous === 1) {
						message = '確定刪除評價嗎 ?'
					} else {
						message = '確定刪除 ' + comment.author.displayname + ' 的評價嗎 ?'	
					}
				}
					
				this.$confirm(message, '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
				}).then(_ => {
					this.loading = true;
					API.deleteComment(comment.id).then((response) => {
						if(response.status) {
							redirectLogin(response.data);
							this.loading = false;
							if(!JSON.parse(response.request.response).error_msg) {
								this.showHint('刪除評價錯誤!');
							} else {
								this.showHint(JSON.parse(response.request.response).error_msg);	
							}
						} else {
							this.initial();	
						}
					});
				}).catch(_ => {});	
			},
			/**
				* setRatingTable 視窗
				* @param  {number} score - score
				* @param  {number} total - total
				* @param  {array}  bar - bar
				* @return none
				*/
			setRatingTable: function(score, total, bar) {
				this.showRatingTable = true;
				this.info.aveRating = Math.ceil(score*10)/10;
				this.info.totalRating = total;
				this.info.ratingBar = bar;
				let totalBar = 0;
				for (let i = 0 ; i < 5 ; i++) {
					totalBar = totalBar + bar[i];
				}
				for (let j = 0 ; j < 5 ; j++) {
					if(totalBar === 0) {
						document.getElementsByClassName('bar-' + (5 - j))[0].style.width = "0%";
					} else {
						document.getElementsByClassName('bar-' + (5 - j))[0].style.width = ((bar[j] / totalBar) * 100).toFixed(0) + "%";
					}
				}
			},
			/**
			  * formatCtime 資源建立時間轉換
			  * @param  {object}  row    - row
			  * @param  {object}  column - column
			  * @return {string}  ctime  - 資源建立時間
    		*/
			formatCtime: function (time) {	
				let date = new Date(time * 1000);
				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				let day = date.getDate();

				if(month < 10) {
					month = '0' + month;
				}

				if(day < 10) {
					day = '0' + day;
				}

				return year + '-' + month + '-' + day;
			},
			clickAuthor() {
				if (this.author && this.authorName) {
					this.$emit('setAuthorList', this.author, this.authorName);
				}
			},
			addFavorite() {
				API.addFavorite(this.info.id,).then((response) => {
                    if(response.status) {
                       this.showHint('加入我的最愛發生錯誤!');
                    } else {
                        this.isFavorite = true;
						this.showAddFavorite = true;
						setTimeout(()=>{
							this.$refs.addFavoriteDiv.classList.add("fade-out");
							}, 100);
					}
                });
			},
			removeFavorite() {
				API.deleteFavorite(this.info.id).then((response) => {
                    if(response.status) {
                    	this.showHint('移除我的最愛發生錯誤!');
                    } else {
                        this.isFavorite = false;
						this.showAddFavorite = false;
					}
                });
			},
		}
	}
</script>

<style scoped lang="scss">
$font-color: #222222;
$font-color2: #1D2327;
$font-color3: #515151;
$border-color: #D5D5D4;
$border-color2: #EEEEEE;

.info {
	margin-top : 30px;
	
	.info-table {
		background-color: white;
		border: $border-color2 1px solid;
    height: auto;
    margin-top: -20px;
    float: left;
		.info-name {
			font-size: 20px;
			color: $font-color;
			line-height: 24px;
			display: inline-block;
			margin-left: 3%;	
			margin-top: 20px;
			padding-bottom: 15px;	
			border-bottom: 1px solid $border-color;
			width: 94%;

			.infoCompulsory {
				float: right;
				font-size: 14px;
  				font-weight: 500;
				border-radius: 2px;
				color: #593C00;
				background-color: #FFE799;
				padding: 0px 8px 0px 8px;
			}

			.infoElective {
				float: right;
				font-size: 14px;
  				font-weight: 500;
				border-radius: 2px;
				color: #035C81;
				background-color: #ADEBFB;
				padding: 0px 8px 0px 8px;
			}

			.like-icon {
				float: right;
				cursor: pointer;
				width: 32px;
				height: 30px;
				margin: 0px 12px 0px 12px;
			}
		}
		.info-description {
			font-size: 16px;
			font-weight: normal;
			color: $font-color;
			line-height: 24px;
			display: inline-block;
			margin-top: 15px;	
			margin-left: 3%;	
			padding-bottom: 15px;	
			border-bottom: 1px solid $border-color;
			width: 94%;	
			white-space: pre-line;
		}
		.info-data {
			margin-left: 3%;
			width: 94%;	
			height: 200px;
			.info-title {
				font-size: 16px;
				color: $font-color2;
				line-height: 24px;
				display: block;
				margin-top: 15px;
				float: left;
				font-weight: normal;
				align-content: start;
				width: 50%;
				.info-item {
					font-size: 16px;
					display: initial;
					margin-left: 25px; 
					color: $font-color3;
					line-height: 24px;
					font-weight: normal;
					width: 50%;	
					float: right;
				}
				.author-item {
					font-size: 16px;
					color: #2E90F4;
					font-family: "PingFang TC", "Microsoft JhengHei", "微軟正黑體", sans-serif;
					padding: 0;
				}
			}	
			.info-title:last-child {
				width: 100%;
				padding-bottom: 30px;	
				border-bottom: 1px solid $border-color;	
			}
		}
		
		.info-comment {
			.info-my-comment {
				width: 100%;
				.comment-title {
					font-size: 14px;
					line-height: 24px;
					color: $font-color2;
					float: left;
					margin-left: 3%;
					margin-top: 10px;
					display: block;
				}
				.my-info {
					margin-left: 3%;
					margin-top: 13px;
					width: 94%;
					height: auto;
					float: left;
					display: block;
					.my-comment {
						width: 100%;
						display: block;
						background-color: white;
						border-radius: 2px; 
						height: auto;
						float: left;
						.my-userinfo {
							display: block;
							line-height: 24px;
							margin-top: 16px;
							display: inline-block;
							width: 100%;
							.user-name {
								font-size: 14px;
								color: $font-color2;	
							}
							img {
								width: 22px;
								height: 22px;
								margin-left:18px;
								margin-right:9px;
								vertical-align: middle;
							}
							.delete-icon {
								height: 16px;
								width: 16px;
								float: right;
								cursor: pointer;
								vertical-align: middle;
							}
							.edit-icon {
								height: 16px;
								width: 16px;
								float: right;
								cursor: pointer;
								vertical-align: middle;
							}
						}
						.my-star-date {
							float: left;
							display: block;
							width: 100%;
							.my-star {
								margin-left: 50px;
								margin-top: 3px;
								float: left;
							}
							.my-date {
								float: left;
								font-size: 12px;
								color: #737373;
								margin-left: 10px;
								line-height: 24px;
							}
						}
						.my-message {
							margin-left: 50px;
							margin-bottom: 10px;
							display: block;
							font-size: 14px;
							line-height: 24px;
							color: $font-color3;
							white-space: pre-line;	
						}
					}
					.my-comment-reply {
						background-color: #FAFCFF;
						border-radius: 2px; 
						width: 100%;
						margin-top: 10px;
						margin-bottom: 16px;
						height: auto;
						float: left;
						.reply-row {
							width: 100%;
							margin-top: 5px;
							float: left;
							display: block;	
							.reply-title {
								font-size: 14px;
								line-height: 24px;
								margin-left:18px;
								color: $font-color2;
								float: left;
								display: block;		
							}	
							.reply-date {
								font-size: 12px;
								line-height: 24px;
								color: $font-color3;
								float: left;
								margin-left:10px;
								display: block;		
							}	
						}
						.reply-message {
							font-size: 14px;
							line-height: 24px;
							color: $font-color3;
							margin:5px 0px 10px 18px;
							float: left;
							display: block;		
							white-space: pre-line;	
						}	
					}		
				}
			}

			.info-rating {
				margin-left: 3%;
				width: 94%;
				float: left;
				display: block;
				margin-top: 30px;
				margin-bottom: 30px;
				.info-rating-score {
					margin-top: 30px;
					margin-left: 30px;
					float: left;
					text-align: center;
					width: 80px;
					.info-score {
						font-size: 60px;	
						color: $font-color2;
					}
					.info-star {
						margin-top: 30px;	
					}
					.info-total-score {
						line-height: 24px;
						color: $font-color3;
						font-size: 14px;
						text-align: center;
					}
				}
				.info-rating-bar {
					margin-left: 30px;
					float: left;
					display: block;
					width: 75%;
					.row-bar:after {
						content: "";
						display: table;
						clear: both;
					}
					.left-bar {
						float: left;
						width: 3%;
						margin-top: 10px;
						font-size: 14px;
						line-height: 24px;
						color: $font-color3;
					}
					.right-bar {
						float: left;
						width: 97%;
						margin-top: 10px;
					}
					.bar-container {
						width: 100%;
						background-color: #f1f1f1;
						text-align: center;
						color: white;
						.bar-5 {height: 18px; background-color:#FFB116; }
						.bar-4 {height: 18px; background-color:rgba(255,177,22,0.8) }
						.bar-3 {height: 18px; background-color:rgba(255,177,22,0.6) }
						.bar-2 {height: 18px; background-color:rgba(255,177,22,0.4) }
						.bar-1 {height: 18px; background-color:rgba(255,177,22,0.2) }
					}					
				}
			}

			.comment-btn {
				margin-left: 3%;
  			color: #737373;
  			font-size: 14px;
  			text-align: center;
				box-sizing: border-box;
  			height: 40px;
  			width: 120px;
  			border: 1px solid #C7CAD1;
  			border-radius: 2px;
				margin-bottom: 20px;
			}

			.other-info {
				margin-left: 3%;
				margin-top: 3px;
				margin-bottom: 5px;
				width: 94%;
				height: auto;
				float: left;
				display: block;
				position: relative;
				background-color: white;
				border-bottom: 1px solid $border-color;
				.other-userinfo {
					display: block;
					line-height: 24px;
					margin-top: 16px;
					width: 100%;
					.user-name {
						font-size: 14px;
						color: $font-color2;	
					}
					img {
						width: 22px;
						height: 22px;
						margin-left:18px;
						margin-right:9px;
						vertical-align: middle;
					}
					.delete-icon {
						height: 16px;
						width: 16px;
						float: right;
						cursor: pointer;
						vertical-align: middle;
					}
					.reply-btn {
						float: right;
						color: #737373;
						font-size: 14px;
						text-align: center;
						box-sizing: border-box;
						margin-top: -10px;
						height: 34px;
						width: 58px;
						border: 1px solid #C7CAD1;
						border-radius: 2px;
					}
					.change-reply-btn {
						float: right;
						color: #737373;
						font-size: 14px;
						text-align: center;
						box-sizing: border-box;
						margin-top: -10px;
						height: 34px;
						width: 98px;
						border: 1px solid #C7CAD1;
						border-radius: 2px;	
					}
				}
				.other-star-date {
					float: left;
					display: block;
					width: 100%;
					.other-star {
						margin-left: 50px;
						margin-top: 3px;
						float: left;
					}
					.other-date {
						float: left;
						font-size: 12px;
						color: #737373;
						margin-left: 10px;
						line-height: 24px;
					}
				}
				.other-comment {
					margin-left: 50px;
					margin-bottom: 13px;
					display: block;
					font-size: 14px;
					line-height: 24px;
					color: $font-color3;	
					white-space: pre-line;	
				}
				.other-reply-comment {
					background-color: #FAFCFF;
					border-radius: 2px; 
					width: 100%;
					margin-bottom: 16px;
					height: auto;
					float: left;
					.reply-row {
						width: 100%;
						margin-top: 5px;
						float: left;
						display: block;	
						.reply-title {
							font-size: 14px;
							line-height: 24px;
							margin-left:18px;
							color: $font-color2;
							float: left;
							display: block;		
						}	
						.reply-date {
							font-size: 12px;
							line-height: 24px;
							color: $font-color3;
							float: left;
							margin-left:10px;
							display: block;		
						}	
					}
					.reply-message {
						font-size: 14px;
						line-height: 24px;
						color: $font-color3;
						margin:5px 0px 10px 18px;
						float: left;
						display: block;	
						white-space: pre-line;		
					}	
				}
			}
		}
	}
	.info-card {
		background-color: white;
		width: 80%;
		height: auto;
		margin-left: 20%;
		margin-top: -20px;
		background-color: white;
		border: $border-color2 1px solid;
		float: left;
		.info-card-title {
			font-size: 20px;
			color: $font-color;
			line-height: 24px;
			display: inline-block;
			margin-left: 6%;	
			margin-top: 20px;
			padding-bottom: 15px;	
			border-bottom: 1px solid $border-color;
			width: 88%;
		}
		.info-card-column {
			border-bottom: 1px solid $border-color2;
			padding-bottom: 10px;	
			padding-top: 10px;	
			width: 88%;
			margin-left: 6%;
			line-height: 34px; 	
			display: inline-block;
		}
		.info-card-column:last-child {
			border-bottom: 1px solid $border-color2;
			padding-bottom: 10px;	
			padding-top: 10px;	
			width: 88%;
			margin-left: 6%;
			line-height: 34px; 	
			margin-bottom: 50px;
		}
		.info-card-icon {
			float: left;
			display: float;
			width: 34px;
			height: 34px;	
			margin-right:8%;
		}
		.info-card-file {
			font-size: 16px;
			color: $font-color;
			cursor: pointer;
			text-align: left;
			display: flex;
			word-break: break-all;
			position: relative;
		}
		.info-card-file:hover {
			color: #2E90F4;
		}
		.tooltip {
			float: right;
			display: block;
		}
		.tooltip .info-download-icon {
			float: right;
			display: block;
			width: 16px;
			height: 16px;	
			/*
			transform: scaleY(-1);
      -moz-transform: scaleY(-1);
      -webkit-transform: scaleY(-1);
      -ms-transform: scaleY(-1);
      */
			cursor: pointer;
		}
		.tooltip .tooltiptext {
  		visibility: hidden;
  		width: 120px;
  		background-color: #626874;
  		color: white;
			margin-left: -30px;
			margin-top: -50px;
  		text-align: center;
  		padding: 7px 7px;
  		border-radius: 6px;
  		/* Position the tooltip text - see examples below! */
  		z-index: 1;
		}
		/* Show the tooltip text when you mouse over the tooltip container */
		.tooltip:hover .tooltiptext {
  		visibility: visible;
		}	
	}
}

.centered {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.add-favorite-message {
	height: 142px;
	width: 232px;
	opacity: 0.9;
	border-radius: 8px;
	background-color: #1D2327;

	text-align:center;
	color: #FFFFFF;
	font-size: 16px;
	line-height: 18px;
	padding-top: 38px;
}

.fade-out {
	transition: opacity 3s ease-in-out;
    opacity: 0;
}
</style>


// WEBPACK FOOTER //
// Info.vue?01594fd4